import http from './http'

const ContestInvest = {
  getByParams: (params) => http.get('/api/contest-invests/', { params }),
  deleteContestInvest: (id) => http.delete(`/api/contest-invests/${id}/`)
}

export default ContestInvest
